import React from "react";
import {NearbyUsersModel, NewUserModel, PlayingFrequencyEnum} from "@/app/api/user";
import styles from "./styles.module.scss";
import UserAvatar from "@/app/components/user_avatar/widget";
import {TextMedium14, ThirtyText} from "@/app/components/texts";
import {s} from "@/app/utils/s";
import {t} from "i18next";
import Space from "@/app/components/space";
import UserSmallData from "@/app/features/find_players/pages/detail_player_page/components/user_small_data/widget";
import LazyAssets from "@/app/utils/assets_widget";
import UserBigData from "@/app/features/find_players/pages/detail_player_page/components/user_big_data/widget";
import {fromEnumKeyToEnumValue, isNumeric} from "@/app/utils/custom_function";
import classNames from "classnames";
import Button from "@/app/components/button";

const DetailPlayerCard: React.FC<DetailPlayerCardProps> = ({
                                                             user,
                                                             userBig,
                                                             className,
                                                             isCard,
                                                             onClick,
                                                             createChat,
                                                             goToCreateAMatch,
                                                             hasLoading
                                                           }) => {
  function getRating(user: NearbyUsersModel | undefined, userBig: NewUserModel | undefined) {
    // user?.ntrpRating ?? t(user?.ntrpRating ?? "–").split(" ")[0] ?? user?.skillLevel ?? userBig?.ntrpRating ?? t(userBig?.ntrpRating ?? "–").split(" ")[0] ?? userBig?.skillLevel
    if(user?.ntrpRating){
      return t(user?.ntrpRating ?? "–").split(" ")[0];
    } else if(user?.skillLevel){
      return user.skillLevel;
    } else if(userBig?.ntrpRating){
      return t(userBig?.ntrpRating ?? "–").split(" ")[0];
    } else if(userBig?.skillLevel){
      return userBig.skillLevel;
    } else {
      return "–";
    }
  }

  const formatPlayingFrequency = (value?: PlayingFrequencyEnum | string): string => {
    if (!value) return "–";
    let s = String(value).trim();
    if (!s) return "–";

    if (s.includes("_")) {
      s = s.toLowerCase().replace(/_/g, " ");
    } else {
      s = s.replace(/([a-z])([A-Z])/g, "$1 $2");
      s = s.toLowerCase();
    }

    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  return (
    <div className={classNames(className)}
         onClick={(createChat && goToCreateAMatch) ? undefined : (onClick ? () => onClick(user) : undefined)}>
      <div className={styles.card}>
        <div className={styles.avatar}>
          <UserAvatar userAvatar={user?.imageLink ?? userBig?.user.imageLink} userName={user?.username ?? ""}/>
        </div>
        <div className={classNames(styles.content, {[styles.card]: isCard})}>
          <ThirtyText text={user?.username ?? userBig?.user.username ?? "-"}/>
          <Space.H32/>
          <div className={styles.userData}>
            <div className={styles.mainData}>
              <UserSmallData icon={<LazyAssets.Exp/>}
                             text={getRating(user, userBig)}/>
              <UserSmallData icon={<LazyAssets.Boll/>} text={user?.matchesCount ?? userBig?.user.matchesCount ?? 0}/>
              <UserSmallData icon={<LazyAssets.Map/>} text={user?.city ?? userBig?.city ?? "–"}/>
            </div>
            <div className={styles.otherData}>
              <UserBigData title={t(s.visitSportClub)} text={"In the past"}/>
              <UserBigData
                title={t(s.play)}
                text={(() => {
                  const fromNearby = user?.playFrequency as PlayingFrequencyEnum | undefined;
                  const fromUserBig = userBig?.user.playFrequency as PlayingFrequencyEnum | undefined;
                  const legacyKey = userBig?.profile?.playingFrequency as string | undefined;

                  const value: PlayingFrequencyEnum | string | undefined =
                    fromNearby
                    ?? fromUserBig
                    ?? (legacyKey
                      ? fromEnumKeyToEnumValue(PlayingFrequencyEnum, legacyKey) as PlayingFrequencyEnum | undefined
                      : undefined);

                  return formatPlayingFrequency(value);
                })()}
              />
              <UserBigData
                title={t(s.experience)}
                text={t(user?.playingDuration ?? userBig?.playingDuration ?? "–")}
              />
            </div>
          </div>
          {!isCard && <Space.H32/>}
          {!isCard && <TextMedium14
              text={
                userBig?.aboutYourself
              }
              className={styles.about}
          />}
          {(createChat && goToCreateAMatch && user) && (
            <>
              <Space.H16/>
              <div className={styles.buttonsDesktop}>
                <Button
                  text={t(s.chat)}
                  onClick={() => createChat(user.id)}
                  isViolet
                  isLoading={hasLoading}
                />
                <Button
                  text={t(s.createAMatch)}
                  onClick={() => goToCreateAMatch(user)}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

interface DetailPlayerCardProps {
  user?: NearbyUsersModel;
  userBig?: NewUserModel;
  className?: string;
  isCard?: boolean;
  onClick?: (user: NearbyUsersModel | undefined) => void;
  createChat?: (userId: number) => void;
  goToCreateAMatch?: (user: NearbyUsersModel) => void;
  hasLoading?: boolean;
}

export default DetailPlayerCard;